export const COLUMNS_WIDTH_SETTINGS = {
  actionCell: 90,
  totalCells: 124,
  otherCells: 124,
  checkboxCell: 40,
  disbursementCell: 110
};
